import { useEffect, useState } from 'react'
import { Dialog, DialogContent } from '@material-ui/core'
import AcceptDocuments from '../views/General/AcceptDocuments'
import { setProvider } from '../redux/features/providerSlice'
import { getProviderConditions } from '../api/providerConditions.service'
import { getProvider } from '../api/providers.service'
import { useDispatch, useSelector } from 'react-redux'

const ChangeProviderAndAcceptDocuments = ({ differentProviderId }) => {
  const dispatch = useDispatch()
  const modal = useSelector((state) => state.modal)
  const [isAcceptDocumentsModalOpen, setIsAcceptDocumentsModalOpen] = useState(false)
  const [selectedProvider, setSelectedProvider] = useState({})
  const handleCloseModalAcceptDocuments = () => {
    setIsAcceptDocumentsModalOpen(false)
  }
  const providerSelected = useSelector((state) => state.provider.id)

  useEffect(() => {
    const handleSelectProvider = async (differentProviderId) => {
      if (differentProviderId === providerSelected) return

      try {
        const conditionsResult = await getProviderConditions(differentProviderId)
        const providerResult = await getProvider(differentProviderId)

        if (conditionsResult.data.every((condition) => condition.isAccepted)) {
          dispatch(setProvider(providerResult.data))
        } else {
          dispatch(setProvider({}))
          setSelectedProvider(providerResult.data)
          setIsAcceptDocumentsModalOpen(true)
        }
      } catch (error) {
        console.error('Error handling provider selection:', error)
      }
    }

    handleSelectProvider(differentProviderId)
  }, [
    dispatch,
    setSelectedProvider,
    setIsAcceptDocumentsModalOpen,
    differentProviderId,
    providerSelected
  ])

  return (
    <Dialog
      open={isAcceptDocumentsModalOpen}
      onClose={handleCloseModalAcceptDocuments}
      maxWidth={'md'}
      fullWidth={true}
      fullScreen={modal.isFullscreen}
    >
      <DialogContent>
        <AcceptDocuments provider={selectedProvider} onClose={handleCloseModalAcceptDocuments} />
      </DialogContent>
    </Dialog>
  )
}

export default ChangeProviderAndAcceptDocuments
